<template>
  <div>
    <!-- <v-card> -->
      <v-card-text>
        <!-- <v-row justify="center"> -->
            <!-- <v-col md="3" sm="3">
            <v-text-field required v-model="eduplusauthid" hint="Username" persistent-hint>
            </v-text-field>
            </v-col>
             <v-col md="3" sm="3">
            <v-text-field type="password" required v-model="pwd" hint="Password" persistent-hint>
            </v-text-field>
             </v-col> -->
                         <v-row>
            <v-text-field required v-model="eduplusauthid" hint="Username" persistent-hint>
            </v-text-field>
            </v-row>
             <v-row>
            <v-text-field type="password" required v-model="pwd" hint="Password" persistent-hint>
            </v-text-field>
             </v-row>
             <v-row class="justify-center" >
            <v-btn @click="checkauth" color="success">Auth</v-btn>
             </v-row>
        <!-- </v-row> -->
      </v-card-text>
    <!-- </v-card> -->
  </div>
</template>
<script>
import axios from "axios";
import sha256 from 'js-sha256'
export default {
  data: () => ({
    //
    eduplusauthid:"",
    pwd:"",
    key:null
  }),
  methods: {
      checkauth(){
          const formData={
              eduplusauthid:this.eduplusauthid,
            //   hashval:sha256(this.pwd+process.env.VUE_APP_SHA_EDU_KEY)
              hashval:sha256(this.pwd+this.key)

          }
          axios
            .post("https://auth.edupluscampus.com/EPAuth/getauth",formData)
            .then(res => {
                console.log("data:",res.data)
                if(res.data.auth=="YES"){
                    this.startSession()
                }
                else{
                    alert("Error:"+res.data.remark)
                }
            })
            .catch(error => {
            })
            .finally(() => {});
            },


            startSession(){
                
                let dns= window.location.hostname;
                let logindevice = localStorage.getItem("logindevice");
                this.message = null
                const data = {
                    uid:this.eduplusauthid,
                    dns :dns,
                    logindevice:logindevice
                }
                axios
            .post("/login/globalAuth",data)
            .then(res => {
                console.log("data:",res.data)
                     if (res.data.msg == "200") {
                            localStorage.setItem("awspath", res.data.awspath)
                            localStorage.setItem("EPS-token", res.data.token);
                            localStorage.setItem("EPS-uid", res.data.uid);
                            if (res.data.policy_read == true) {
                                if (res.data.firstlogin == "1") {
                                    localStorage.setItem("first-login", res.data.firstlogin);
                                    this.$router.push("/update-password");
                                } else {
                                    localStorage.setItem("first-login", "0");
                                    this.$router.push("/home");
                                }
                            } else {
                                this.dialog = true
                            }
                            //window.location="/home"
                        } else {
                            this.message = "Please check your credentials!!!";
                            this.alert = true
                            localStorage.setItem("EPS-token", "");
                            localStorage.setItem("EPS-uid", "");
                        }
               
            })
            .catch(error => {
            })
            .finally(() => {});
            },

            getKey(){
                          axios
            .post("login/getKey")
            .then(res => {
                alert(res.data.key)
                this.key = res.data.key
            })
            .catch(error => {
            })
            .finally(() => {});
            },
  },
  mounted() {
      this.getKey()
  }
};
</script>